/// Mesmos números do ECustomFieldType do backend. Só crescem no fim.
export enum ECustomFieldType {
    Text = 0,
    Number = 1,
    Date = 2,
    List = 3,
    Boolean = 4,
}

export interface CustomFieldResponse {
    id: string;
    name: string;
    type: ECustomFieldType;
    required: boolean;
    sortOrder: number;
    /// Arquivado não aparece na tela do lead, mas os valores continuam gravados.
    active: boolean;
    /// Vazio fora do tipo lista.
    options: string[];
}
